import { getWindowOrThrow } from "../../globals/getWindow";
import { singletonGetter } from "../../singletons/getter";

import { ActionName } from "./types";

export class ActionStartTimeStore {
  private actionStartTimeMap: Map<ActionName, number> = new Map();

  static get = singletonGetter(ActionStartTimeStore);

  recordActionStartTime = (actionName: ActionName): number => {
    const { performance } = getWindowOrThrow();
    const startTime = performance.now();
    this.actionStartTimeMap.set(actionName, startTime);
    return startTime;
  };

  getActionStartTime = (actionName: ActionName): number | undefined => {
    return this.actionStartTimeMap.get(actionName);
  };

  cleanActionStartTime = (actionName: ActionName) => {
    this.actionStartTimeMap.delete(actionName);
  };
}
